if (!window.dAgency) window.dAgency = {};
window.dAgency.initJsAccordions = (accordion) => {
  if (!accordion || !accordion.querySelector('summary') || !accordion.classList.contains('js-accordion')) return;

  const summary = accordion.querySelector('summary');
  summary.addEventListener('click', () => {
    if (!accordion.hasAttribute('open')) {
      document.querySelectorAll('details[open].js-accordion.accordion-disclosure').forEach(openAccordion => {
        openAccordion.removeAttribute('open');
      });
    }
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('details.js-accordion'), (el) => {
    window.dAgency.initJsAccordions(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('details.js-accordion'), (el) => {
      window.dAgency.initJsAccordions(el);
    });
  });
}
